import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    settheTicketsystemrecordgetListDataActions,

} from "../../../../../../../Redux/Slice";
import _ from "lodash";
import TabTables from "../../../../../../AppComponent/TabTables";



export const TicketTablesdash = ({activeButton, setActiveButton ,


       datas,
  PriorityValues,
  SttausValues,
  Client,
  range,
  date
 }) => {
                const state = useSelector((state) => state);
                const dispatch = useDispatch();

        const [search, setsearch] = useState("");
        const [pageSize, setPageSize] = useState(20);
        const [dtpageindex, setdtPageindex] = useState(1);
                    const [currentPage, setCurrentPage] = useState(1);




                    
 const HandletheActived = (tab) => {
    setActiveButton(tab);
  }



       const pagesize = (arg) => {
    };
    const pageindex = (arg) => {
        setdtPageindex(arg);
    };

    function tochange(e) {
        setdtPageindex(1);
        debouncedSearch(e);
    }
    const debouncedSearch = useMemo(
        () =>
            _.debounce((e) => {
                setsearch(e);
            }, 500),
        []
    );
    React.useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);



    const capitalizeEachWord = (str) => {
        return str
            .split(' ') // Split the string into an array of words
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
            .join(' '); // Join the words back into a string
    };

    const truncateText = (text, maxLength) => {
        if (text.length <= maxLength) {
            return text;
        }
        return text.substring(0, maxLength) + "...";
    };

       const formatedDateListwithouttime = (dateString) => {
        const date = new Date(dateString);

        // Options for date formatting (only date)
        const dateOptions = {
            month: "short", // e.g., Dec
            day: "2-digit", // e.g., 22
            year: "numeric", // e.g., 2024
        };

        // Options for time formatting (only time)
        const timeOptions = {
            hour: "2-digit", // e.g., 02
            minute: "2-digit", // e.g., 16
            hour12: true, // e.g., AM/PM format
        };

        // Format the date and time separately
        const formattedDate = date.toLocaleDateString("en-US", dateOptions);
        const formattedTime = date.toLocaleTimeString("en-US", timeOptions);

        // Combine the formatted date and time
        return `${formattedDate}`;
    };

        const columns = [
        {
            Header: "Created ",
            accessor: "created_at",
            Cell: (row) => {


                return (
                    <>
                        <div className="CreatedDatelisted">
                            {row.row.original.created_at ? formatedDateListwithouttime(row.row.original.created_at) : ""}

                        </div>
                    </>
                );
            },

        },


        {
            Header: "Category",
            accessor: "",
            Cell: ({ cell }) => {
                let data = cell.row.original;
                return (
                    <div className="ParaTickets">
                        <p> {data.clientsub_category_id?.issue_id?.name ?
                            capitalizeEachWord(data.clientsub_category_id?.issue_id?.name.toLowerCase()) :
                            "-"

                        }</p>
                    </div>
                );
            },
        },
        {
            Header: "Subcategory",
            accessor: "",
            Cell: ({ cell }) => {
                let data = cell.row.original;
                return (
                    <div className="ParaTickets">
                        <p> {data.clientsub_category_id?.name ?
                            capitalizeEachWord(data.clientsub_category_id?.name.toLowerCase()) : "-"}</p>
                    </div>
                );
            },
        },

        {
            Header: "Description",
            accessor: "",
            Cell: ({ cell }) => {
                let data = cell.row.original;
                return (
                    <div className="ParaTickets">
                        <p
                        >{data.remarks ? truncateText(capitalizeEachWord(data.remarks.toLowerCase()), 60) : "-"}</p>

                    </div>
                );
            },
        },




  
        {
            Header: "Priority",

            accessor: "",
            Cell: ({ cell }) => {
                let data = cell.row.original;

                // Sub-category priority colors
                const priorityColor = data?.clientsub_category_id?.Priority === "0"
                    ? "hsla(43, 100%, 50%, 1)" // Low
                    : data?.clientsub_category_id?.Priority === "1"
                        ? "hsla(32, 92%, 59%, 1)" // Medium
                        : data?.clientsub_category_id?.Priority === "2"
                            ? "hsla(7, 85%, 58%, 1)" // High
                            : "";

                return (
                    <span className="PriorityColumns">
                        {data.clientsub_category_id?.Priority === "0" || data.clientsub_category_id?.Priority === "1" || data.clientsub_category_id?.Priority === "2" ? (
                            <button
                                style={{
                                    backgroundColor: priorityColor,
                                    border: "none",
                                    color: "#fff", // Text color remains white for readability
                                    padding: "5px 10px",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    width: "97px"
                                }}
                            >
                                {data.clientsub_category_id?.Priority === "0"
                                    ? "Low"
                                    : data.clientsub_category_id?.Priority === "1"
                                        ? "Medium"
                                        : "High"}
                            </button>
                        ) : (
                            "---"
                        )}
                    </span>
                );
            },
        },



        {
            Header: "Status",
            accessor: "",
            Cell: ({ cell }) => {
                let data = cell.row.original;
                return (
                    <div className="TicketButtons">

                        <>
                            <button className='Buttonstatus'
                                style={{
                                    background: data.status == 0 ? "#FDEDE9" : // Open - light background
                                        data.status == 1 ? "#FFF8E5" : // In Progress - yellow background
                                            data.status == 2 ? "#E7F8ED" : // Completed - light green background
                                                data.status == 3 ? "#DFFFE3" : // Close - light green background for Close
                                                    "#FFDDDD", // Default for Reopen - light red background
                                    color: data.status == 0 ? "#ED4C28" : // Open - red text
                                        data.status == 1 ? "#FFB800" : // In Progress - yellow text
                                            data.status == 2 ? "#12B749" : // Completed - green text
                                                data.status == 3 ? "#8BC34A" : // Close - light green text for Close
                                                    "#ED4C28", // Default for Reopen - red text
                                }}
                            >
                                {data.status == 0 ? "Open" :
                                    data.status == 1 ? "In Progress" :
                                        data.status == 2 ? "Review" :
                                            data.status == 3 ? "Resolved" : "Reopened"}


                            </button>

                        </>

                    </div>
                );
            },
        },



    ];

  return (
    <>

           <div style={{ width:"100%" }}>
                    <TabTables
                        data={state.TrackingrecordgetOfSystemList.TrackingReport}
                        columns={columns}
                        totalItems={state.TrackingrecordgetOfSystemList.Total_Count}
                        currentPage={currentPage}
                        onChange={tochange}
                        setCurrentPage={setCurrentPage}
                        pagesize={pagesize}

                        dtpagesize={pageSize}
                        dtpageindex={dtpageindex}
                        pageindex={pageindex}
                      

                        datacount={state.TrackingrecordgetOfSystemList.Total_Count}


setActiveButton={setActiveButton} 
activeButton={activeButton} 
HandletheActived={HandletheActived}
                        MakeCreate={false}


                                   datas={datas}
  PriorityValues={PriorityValues}
  SttausValues={SttausValues}
  Client={Client}
range={range} 
  date={date}

                        


                    />

                </div>


    </>
  )
}
